// @ts-nocheck
import { emsCodeList, emsMainCodeList, chronicCareCode, BundleType } from '../constants/formConstants';
import moment, { Moment } from 'moment';
import { format, isValid, parseISO } from 'date-fns';
import { getStringFromDate } from './groups/helpers';
const getIsChronicCareEnabled = ({ start_dt, end_dt }) => {
  if (start_dt) {
    if (end_dt) {
      const momentStartDate: Moment = moment.utc(start_dt);
      const momentEndDate: Moment = moment.utc(end_dt);
      const now: Moment = moment();
      return momentEndDate.isAfter(now) && momentStartDate.isBefore(momentEndDate);
    }
    return true;
  }
  return false;
};

const disabledByDefaultProducts: string[] = ['DERM', 'GM', 'BH', 'PRIM360CARE', 'chronicCare'];

export function transformIncomeData(fetchedValues) {
  if (!fetchedValues) {
    return {};
  }

  const { groups, contacts, ...base } = fetchedValues;
  const flattenedContacts = contacts?.reduce((o, { type, ...c }) => {
    const contactKey = `contacts--${type}`;
    if (['Reporters', 'Marketing'].includes(type)) {
      if (!o[contactKey]) {
        o[contactKey] = [];
      }
      o[contactKey].push({ ...c, type });
    } else {
      Object.keys(c).forEach((key) => {
        o[`${contactKey}--${key}`] = c[key];
      });
    }
    return o;
  }, {});

  const adjustedGroups = groups?.reduce(
    (a, { futureProducts = [], futureProductsCCM, products, planCodes = [], ...g }: any) => {
      let found_efb = false;
      let emsEndDate = null;
      let emsStartDate = null;
      let hasEms = false;

      if (!planCodes.length) planCodes.push({ code: '' });

      const flattenedProducts = products?.reduce((pO, { code, type, ...p }) => {
        if (!found_efb && emsMainCodeList.includes(code.toUpperCase()) && type === 'EFB') {
          found_efb = true;
        }
        if (chronicCareCode.includes(code.toUpperCase())) {
          const { start_dt, end_dt } = p;
          pO[`products--${code}--start_dt`] = start_dt;
          pO[`products--${code}--end_dt`] = end_dt;
          pO[`products--${code}--bundleType`] = p?.bundleType === BundleType.Anchor ? 'PLUS' : 'STANDALONE';
          pO[`products--${code}--isEnabled`] =
            p?.bundleType === BundleType.NonAnchor ? false : getIsChronicCareEnabled({ start_dt, end_dt });
          // Add SPP props
          if (p?.spp) {
            pO[`products--SPP--start_dt`] = p.spp_start_dt ? getStringFromDate(p.spp_start_dt) : null;
            pO[`products--SPP--end_dt`] = p.spp_end_dt ? getStringFromDate(p.spp_end_dt) : null;
            pO[`products--SPP--isEnabled`] = true;
          }
        } else if (!emsCodeList.includes(code) && !chronicCareCode.includes(code)) {
          Object.keys(p).forEach((key) => {
            const thirdOctet = `${key}${type && key === 'member_copay' ? `__${type}` : ''}`;
            pO[`products--${code}--${thirdOctet}`] = p[key];
          });
          // we have an end_dt and its in the past
          pO[`products--${code}--isEnabled`] = !(p.end_dt && moment().isAfter(p.end_dt));
        }

        if (!hasEms && emsMainCodeList.includes(code.toUpperCase()) && !chronicCareCode.includes(code.toUpperCase())) {
          emsStartDate = p['start_dt'];
          emsEndDate = p['end_dt'];
          hasEms = true;
        }
        return pO;
      }, {});

      if (flattenedProducts) {
        // we have an end_dt and its in the past
        flattenedProducts['products--EMS--isEnabled'] = emsEndDate && moment().isAfter(emsEndDate) ? false : hasEms;
        flattenedProducts['products--EMS--isEfb'] = found_efb;
        flattenedProducts['products--EMS--start_dt'] = emsStartDate;
        flattenedProducts['products--EMS--end_dt'] = emsEndDate;
      }

      const chronicCareProducts = products?.filter(
        ({ code, bundleType }) => chronicCareCode.includes(code.toUpperCase()) && bundleType !== BundleType.NonAnchor
      );

      const chronicCareProduct = chronicCareProducts.find((product) => getIsChronicCareEnabled(product));
      if (chronicCareProduct) {
        flattenedProducts['products--chronicCare--start_dt'] = chronicCareProduct['start_dt'];
        flattenedProducts['products--chronicCare--end_dt'] = chronicCareProduct['end_dt'];
        flattenedProducts['products--chronicCare--isEnabled'] = chronicCareProducts.some(getIsChronicCareEnabled);
      }

      const flattenProductsKeys = Object.keys(flattenedProducts);

      disabledByDefaultProducts.forEach((product: string) => {
        const enabledKey = `products--${product}--isEnabled`;
        if (!flattenProductsKeys.includes(enabledKey)) {
          flattenedProducts[enabledKey] = false;
        }
      });

      const flattenedFutureProducts = futureProducts?.reduce(
        (pO, { code, type, ...p }: { type: string; code: string }) => {
          Object.keys(p).forEach((key) => {
            const thirdOctet = `${key}${type && key === 'member_copay' ? `__${type}` : ''}`;
            pO[`futureProducts--${code}--${thirdOctet}`] = p[key];
          });
          return pO;
        },
        {}
      );

      // We make the same formatting for the future ccm updates as current ccm services
      const flattenedFutureProductsCCM = futureProductsCCM?.reduce(
        (pO, { code, type, ...p }: { type: string; code: string }) => {
          const { start_dt, end_dt, bundleType } = p;
          if (start_dt) {
            pO[`futureProductsCCM--${code}--start_dt`] = getStringFromDate(start_dt);
            pO[`futureProductsCCM--${code}--end_dt`] = end_dt ? getStringFromDate(end_dt) : null;
            pO[`futureProductsCCM--${code}--bundleType`] = bundleType === BundleType.Anchor ? 'PLUS' : 'STANDALONE';
            pO[`futureProductsCCM--${code}--isEnabled`] = end_dt ? false : bundleType !== BundleType.NonAnchor;
            if (p?.spp) {
              pO[`futureProductsCCM--SPP--start_dt`] = p.spp_start_dt ? getStringFromDate(p.spp_start_dt) : null;
              pO[`futureProductsCCM--SPP--end_dt`] = p.spp_end_dt ? getStringFromDate(p.spp_end_dt) : null;
              pO[`futureProductsCCM--SPP--isEnabled`] = !p.spp_end_dt;
            }
            // Case when a future service has been unselected
          } else if (!start_dt && end_dt) {
            pO[`futureProductsCCM--${code}--start_dt`] = undefined;
            pO[`futureProductsCCM--${code}--end_dt`] = getStringFromDate(end_dt);
            pO[`futureProductsCCM--${code}--bundleType`] = bundleType === BundleType.Anchor ? 'PLUS' : 'STANDALONE';
            pO[`futureProductsCCM--${code}--isEnabled`] = false;
          }
          return pO;
        },
        {}
      );

      // If there are future updates for ccm, we need to set the update date
      if (flattenedFutureProductsCCM) {
        let futureChronicCareStartDt: string;
        chronicCareCode.forEach((code) => {
          if (flattenedFutureProductsCCM[`futureProductsCCM--${code}--start_dt`] && !futureChronicCareStartDt) {
            futureChronicCareStartDt = flattenedFutureProductsCCM[`futureProductsCCM--${code}--start_dt`];
          } else if (flattenedFutureProductsCCM[`futureProductsCCM--${code}--end_dt`] && !futureChronicCareStartDt) {
            futureChronicCareStartDt = flattenedFutureProductsCCM[`futureProductsCCM--${code}--end_dt`];
          }
        });
        flattenedFutureProductsCCM['futureProductsCCM--CCM--start_dt'] = futureChronicCareStartDt;
      }

      const adjustedPlanCodes = planCodes?.map((planCode) => ({
        ...planCode,
        classCodes: planCode.classCodes?.map((classCode) => ({ ...classCode, isPlainText: true })) || [],
        bpCodes: planCode.bpCodes?.map((bpCode) => ({ ...bpCode, isPlainText: true })) || []
      }));

      a.push({
        ...g,
        ...flattenedProducts,
        ...flattenedFutureProducts,
        ...flattenedFutureProductsCCM,
        planCodes: adjustedPlanCodes
      });

      return a;
    },
    []
  );

  const getLastUpdatedBy = () => {
    const { UpdatedByName, UpdatedAt } = base;
    const updDate = isValid(parseISO(UpdatedAt)) ? format(parseISO(UpdatedAt), 'MM/dd/yyyy hh:mm a') : '';
    if (UpdatedByName || updDate) {
      return `${UpdatedByName || '--'} ${updDate}`.trim();
    }
    return '---';
  };

  return { ...base, ...flattenedContacts, groups: adjustedGroups, lastUpdatedBy: getLastUpdatedBy() };
}
